var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageShell',{attrs:{"active":_vm.active}},[_c('section',{staticClass:"text-page"},[_c('h1',[_vm._v(_vm._s(_vm.articles.title))]),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"content"},[_c('div',{staticClass:"rich-content",domProps:{"innerHTML":_vm._s(_vm.richContent)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }